import * as React from "react";
import RoutesInApp from "./router/routes";
import "react-block-ui/style.css";
import "./index.css"
// RoutesComponent
import { Routes, Route} from "react-router-dom";
import { createBrowserHistory } from "history";
import configureStore from "./store/configureStore";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./themes";
import { Provider } from "react-redux";
import Template from "./components/Common/ElementInForm/TemplateDialog";
import ReduxBlockUi from "react-block-ui/redux";
import { Grid } from "@mui/material";
import CookieCondition from "view/font/Home/CookieCondition";


const history = createBrowserHistory({ window: window });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

export default function App() {
  return (
    <Provider store={store}>
      <ReduxBlockUi
        tag="div"
        block="BLOCK_UI"
        unblock={["UNBLOCK_UI", /fail/i]}
      >
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Routes >
            {RoutesInApp.map((o: any) => {
              return (
                <Route path={o.path} key={o.path} element={o.layout ? (
                  <o.layout {...o.propsData}>
                    <o.component {...o.propsData} />
                    {/* <LoginWarning /> */}
                    <Template />
                  </o.layout>
                ) : (
                  <>
                    <o.component {...o.propsData} />
                    {/* <LoginWarning /> */}
                    <Template />
                  </>
                )} />
              );
            })}
          </Routes>
          {/* cookie policy */}
          <Grid>
            <CookieCondition />
          </Grid>
        </ThemeProvider>
      </ReduxBlockUi>
    </Provider>
  );
};